module.exports = {"approval":{"topic":"Beurteilen Sie Ihr Projekt %PROJECT%","body":"<p>Hallo %FIRST% %LAST%,</p>\n<p>Folgen Sie diesem Link, um Ihr Projekt anzusehen und freizugeben.</p>\n<p><a href='%LINK%'>%LINK%</a></p>\n<p>Danke,</p>\n<p>Ihr %TEAM% Team</p>\n\nTHIS TEMPLATE IS CURRENTLY UNUSED!"}}


//////////////////
// WEBPACK FOOTER
// ./src/constants/email_templates.json
// module id = 469
// module chunks = 2